import React from "react";
import { AppColors } from "../../utility/AppColors";
import { ImageBackground, Text, View } from "react-native";
import { AppFontStyle } from "../../styles/AppFontStyle";
import UpgradeComponent from "../home-common-components/UpgradeComponent";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import { AppImages } from "../../utility/AppImages";
import { useAuthProvider } from "../../context/AuthContext";

const Listing = ({ items, styles, isUpgradeData }) => {
  const { isActiveSubscriptionFound } = useAuthProvider();
  // const isActiveSubscriptionFound = false;

  return (
    <View
      style={[
        styles.ul,
        {
          paddingBottom: isUpgradeData ? 0 : 10,
          paddingTop: isUpgradeData ? 10 : 0,
        },
      ]}
    >
      {items.map((item, index) => (
        <View key={index} style={styles.li}>
          <Text
            style={[
              styles.bulletPoint,
              {
                color: isActiveSubscriptionFound
                  ? AppColors.green_4CD964
                  : isUpgradeData
                  ? AppColors.green_4CD964
                  : AppColors.white,
              },
            ]}
          >
            •
          </Text>
          <Text
            style={[
              styles.liText,
              {
                color: isActiveSubscriptionFound
                  ? AppColors.green_4CD964
                  : isUpgradeData
                  ? AppColors.green_4CD964
                  : AppColors.white,
                // lineHeight:16
              },
            ]}
          >
            {item}
          </Text>
        </View>
      ))}
    </View>
  );
};
const SubscriotionPlanComponent = ({ styles }) => {
  const deviceSize = useDeviceSize();
  const { isActiveSubscriptionFound } = useAuthProvider();

  // const isActiveSubscriptionFound = false;

  const freeItems = [
    "Keep 50% of your winnings",
    "Higher transaction fees: 50% on ticket sales profit",
    "Standard customer support",
    "Regular visibility: No priority placement",
    "No access to exclusive features",
    "Standard profile credibility",
  ];

  const upgradeItems = [
    "Keep 80% of your winnings (vs. 50% for non-subscribers)",
    "Reduced transaction fees: Only 5% on ticket sales profit",
    "Priority customer support",
    "Enhanced visibility: Priority placement on the platform",
    "Exclusive content and features",
    "Boosted credibility: Subscription badge on your profile",
  ];

  const staticItems = [
    "Enjoy 80% of your winnings (vs. 50% for non-subscribers)",
    "Reduced transaction fees: Only 5% on ticket sales profit",
    "Priority customer support",
    "Enhanced visibility: Priority placement on the platform",
    "Exclusive content and features",
    "Boosted credibility: Subscription badge on your profile",
  ];

  return (
    <View
      style={{
        backgroundColor: AppColors.purple_453B50,
        width:
          deviceSize === DEVICE_SIZES.SM || deviceSize === DEVICE_SIZES.XS
            ? "100%"
            : 350,
        borderRadius: 10,
        paddingHorizontal: 10,
        paddingVertical: 60,
      }}
    >
      <Text style={[AppFontStyle.BOLD_ANYBODY_20, { color: AppColors.white }]}>
        Current Plan
      </Text>
      <Text
        style={[
          AppFontStyle.BOLD_ANYBODY_32,
          { color: AppColors.white, marginTop: 15, marginBottom: 10 },
        ]}
      >
        {isActiveSubscriptionFound ? "Monthly" : "FREE"}
      </Text>
      <View>
        <Listing
          items={isActiveSubscriptionFound ? staticItems : freeItems}
          styles={styles}
          isUpgradeData={false}
        />
      </View>
      <View style={{ alignItems: "center" }}>
        <ImageBackground
          source={AppImages.UpgradeBtnBg}
          style={{
            width: 303,
            height: 49,
            justifyContent: "center",
            alignItems: "center",
            borderRadius: 91,
            overflow: "hidden",
            marginTop: isActiveSubscriptionFound ? 50 : 0,
          }}
        >
          <UpgradeComponent
            styles={styles}
            fontStyle={AppFontStyle.BOLD_ANYBODY_28}
            imageIsVisible={false}
            title={isActiveSubscriptionFound ? "Upgrade" : "Upgrade to Pro"}
            isUpdate={true}
          />
        </ImageBackground>
      </View>
      {!isActiveSubscriptionFound && (
        <View>
          <Listing items={upgradeItems} styles={styles} isUpgradeData={true} />
        </View>
      )}
    </View>
  );
};

export default SubscriotionPlanComponent;
